import React, { useEffect } from "react";
import { RootState, useAppDispatch } from "../state/store";
import { useSelector } from "react-redux";
import { CheckoutStatus, createCheckout } from "../state/checkout";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
import { Select_Donation_Amount_Path } from "../applicationRoutes";
import { RenderAmount } from "../components/renderAmount";
import "./payDonationAmount.css";

export function PayDonationAmount() {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const donationInfo = useSelector((state: RootState) => state.DonationInfo.data);
    const checkoutInfo = useSelector((state: RootState) => state.CheckoutInfo);

    useEffect(() => {
        dispatch(createCheckout({
            donationAmount: donationInfo.donationAmount!,
            email: donationInfo.email,
            mobileNumber: donationInfo.mobileNumber,
            name: donationInfo.name
        }));
    }, []);

    const onErrorBtnClicked = (evt: any) => {
        navigate("/select-donation-amount");
    }

    const renderCreateCheckoutInProgress = () => {
        return (<div className="d-grid gap-2" style={{ marginTop: '20px' }}>
            <Button variant="primary" disabled size="lg">
                <Spinner as="span" animation="grow" role="status" aria-hidden="true" /> &nbsp;&nbsp;
                Please wait ...
            </Button>
        </div>);
    }

    const renderCreateCheckoutSuccessful = () => {
        return (<div className="d-grid gap-2" style={{ marginTop: '20px' }}>
            <Button variant="primary" disabled size="lg" style={{ backgroundColor: "#ffffff", color: "#7F499D" }}>
                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> &nbsp;&nbsp;
                Please pay using EFTPOS device ...
            </Button>
        </div>);
    }

    const renderCreateCheckoutError = () => {
        return (<div className="d-grid gap-2" style={{ marginTop: '20px' }}>
            <Button variant="danger" size="lg" onClick={onErrorBtnClicked}>
                Error with Payment. Please try again.
            </Button>
            <p>
                {checkoutInfo.error}
            </p>
        </div>);
    }

    const renderCheckoutState = () => {
        if (checkoutInfo.checkoutStatus == CheckoutStatus.none)
            return (<React.Fragment />);

        const status = checkoutInfo.checkoutStatus as CheckoutStatus;
        switch (status) {
            case CheckoutStatus.createInProgress:
                return renderCreateCheckoutInProgress();
            case CheckoutStatus.createSuccess:
                return renderCreateCheckoutSuccessful();
            case CheckoutStatus.createError:
                return renderCreateCheckoutError();
            case CheckoutStatus.checkoutComplete:
                return (<Navigate to={Select_Donation_Amount_Path} replace={true} />);
        }
    }

    return (
        <Container className="pay-donation-amount">
            <Row>
                <Col md={12} sm={12} lg={12}>
                    <RenderAmount onClicked={() => { }} value={donationInfo.donationAmount!} selected={false} />
                </Col>
            </Row>

            <Row>
                <Col md={12} sm={12} lg={12}>
                    {renderCheckoutState()}
                </Col>
            </Row>
        </Container>)
}